import React, { useState, useEffect } from 'react';
import { FormCompletionCheckMark, StyledExitIntentPopup, ContentContainer, ContentHeader, ContentBody, PopupTitle, PopupSubtitle, ClosePopupButton, PopupNoThanks } from './ExitIntentPopup.styles';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import MarketoFormMediator from "../MarketoFormMediator"

const popUpDelay = 604800000; // 1000ms * 60s * 60m * 24h * 7d

const ExitIntentPopup = () => {
    const isBrowser = typeof window !== "undefined";
    const [formData, setFormData] = useState();
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [lastShown, setLastShown] = useState(isBrowser ? window.localStorage.getItem("exitIntentPopupTimestamp") : Date.now());

    const allFormData = {
        '1': {
            id: 1790,
            title: 'Want a free Corporate Accounts demo?',
            subtitle: 'Enter your email and we’ll be in touch with more information about building the perfect meal perks program.'
        }
    };

    const loadPopupTemplate = async () => {
        const formToServe = allFormData[1];
        setFormData(formToServe);
    };

    const setMouseOut = (event) => {
        const popup = document.getElementById('exit-intent-popup');
        if (popup && event.toElement === null && event.relatedTarget === null) {
            if (popup.dataset.visible === "false") {
                popup.dataset.visible = "true";
            }
        }
    }

    useEffect(() => {
        if (!lastShown) {
            setLastShown(window.localStorage.getItem("exitIntentPopupTimestamp"));
        }
        if (isBrowser) {
            if (formData) {
                document.addEventListener('mouseout', setMouseOut, false);
            } else {
                loadPopupTemplate();
            }
        }
    }, [lastShown, isBrowser, formData, loadPopupTemplate]);

    const handleSubmit = () => {
        setFormSubmitted(true);
        if (isBrowser) window.localStorage.setItem("exitIntentPopupTimestamp", Date.now());
        setLastShown(Date.now());
        return false;
    }

    const handleClose = () => {
        let popup = document.getElementById('exit-intent-popup');
        if (popup) popup.dataset.visible = "false";
        if (isBrowser) window.localStorage.setItem("exitIntentPopupTimestamp", Date.now());
        setLastShown(Date.now());
        if (formSubmitted) setFormSubmitted(false);
    }

    if ( formSubmitted ) {
        return (
            <StyledExitIntentPopup id="exit-intent-popup" data-visible="true" data-title={formData?.title}>
                <ContentContainer>
                    <ContentHeader />
                    <ContentBody>
                        <FormCompletionCheckMark />
                        <PopupTitle className="popup-title">Thanks for reaching out, we'll be in touch shortly!</PopupTitle>
                        <PopupSubtitle className="popup-subtitle">In the meantime, check out our blog to learn more about supporting your hybrid workforce.</PopupSubtitle>
                        <Button
                            to="/blog/"
                            type="primary"
                            onClick = {() => handleClose()}
                        >See Blog</Button>
                    </ContentBody>
                    <ClosePopupButton
                        onClick={() => handleClose()}
                    />
                </ContentContainer>
            </StyledExitIntentPopup>
        );
    } else if (lastShown <= Date.now() - popUpDelay) {
        return (
            <StyledExitIntentPopup id="exit-intent-popup" data-visible="false" data-title={formData?.title}>
                <ContentContainer>
                    <ContentHeader />
                    <ContentBody>
                        <PopupTitle className="popup-title">{formData?.title}</PopupTitle>
                        <PopupSubtitle className="popup-subtitle">{formData?.subtitle}</PopupSubtitle>
                        {
                            !!formData && <MarketoFormMediator
                                id={[ formData?.id ]}
                                onSubmit={() => handleSubmit()}
                                placeholder="Email address"
                                eventCategory="exit intent"
                                eventAction="submit exit intent"
                            />
                        }
                        <PopupNoThanks
                            className="no-thanks"
                            onClick={() => handleClose()}
                        >{'No, Thanks'}</PopupNoThanks>
                    </ContentBody>
                    <ClosePopupButton
                        onClick={() => handleClose()}
                    />
                </ContentContainer>
            </StyledExitIntentPopup>
        );
    } else return null;
};

export default ExitIntentPopup;

ExitIntentPopup.propTypes = {
    eventCategory: PropTypes.string,
    eventAction: PropTypes.string,
  };
  
ExitIntentPopup.defaultProps = {
    eventCategory: "marketo form interaction",
    eventAction: "submit_cta"
  };